export default __webpack_public_path__ + "static/media/conduiit(infrev).7636bace.svg";